import { render, staticRenderFns } from "./editorialBoard.vue?vue&type=template&id=16a5ae1e&"
import script from "./editorialBoard.vue?vue&type=script&lang=js&"
export * from "./editorialBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports